/**
 * @flow
 * @relayHash c3c8930059676a252c337a94d2fb1e8d
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type RemoveTenantVueSharePermissionMutationVariables = {|
  guestTenantId: string,
  ownerTenantId: string,
|};
export type RemoveTenantVueSharePermissionMutationResponse = {|
  +removeTenantVueSharePermission: ?{|
    +ownerTenant: ?{|
      +id: string,
      +name: string,
    |},
    +guestTenant: ?{|
      +id: string,
      +name: string,
    |},
  |}
|};
export type RemoveTenantVueSharePermissionMutation = {|
  variables: RemoveTenantVueSharePermissionMutationVariables,
  response: RemoveTenantVueSharePermissionMutationResponse,
|};
*/


/*
mutation RemoveTenantVueSharePermissionMutation(
  $guestTenantId: ID!
  $ownerTenantId: ID!
) {
  removeTenantVueSharePermission(guestTenantId: $guestTenantId, ownerTenantId: $ownerTenantId) {
    ownerTenant {
      id
      name
    }
    guestTenant {
      id
      name
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "guestTenantId",
    "type": "ID!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "ownerTenantId",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "id",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  }
],
v2 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "removeTenantVueSharePermission",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "guestTenantId",
        "variableName": "guestTenantId"
      },
      {
        "kind": "Variable",
        "name": "ownerTenantId",
        "variableName": "ownerTenantId"
      }
    ],
    "concreteType": "RemoveTenantVueSharePermission",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "ownerTenant",
        "storageKey": null,
        "args": null,
        "concreteType": "TenantNode",
        "plural": false,
        "selections": (v1/*: any*/)
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "guestTenant",
        "storageKey": null,
        "args": null,
        "concreteType": "TenantNode",
        "plural": false,
        "selections": (v1/*: any*/)
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "RemoveTenantVueSharePermissionMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "RemoveTenantVueSharePermissionMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "RemoveTenantVueSharePermissionMutation",
    "id": null,
    "text": "mutation RemoveTenantVueSharePermissionMutation(\n  $guestTenantId: ID!\n  $ownerTenantId: ID!\n) {\n  removeTenantVueSharePermission(guestTenantId: $guestTenantId, ownerTenantId: $ownerTenantId) {\n    ownerTenant {\n      id\n      name\n    }\n    guestTenant {\n      id\n      name\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd3bb59f5f70384cd3e1c3a3e0a9527a9';
module.exports = node;
